import React from 'react'

const Deskripsi = () => {
  return (
    <>
      <div className="w-full bg-white p-5 rounded">
        <h1 className="font-medium text-xl">Deskripsi Mentoring</h1>
        <p className="text-neutral font-normal text-base mt-2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit facere, veniam voluptates reiciendis pariatur maxime beatae nemo obcaecati veritatis laboriosam?</p>
      </div>
    </>
  )
}

export default Deskripsi